import { useEnv } from '../context/env-context';
import { useSettings } from '../context/settings-context';

// Resolves the merchant's public storefront base URL. Prefers the configured `merchantUrl`,
// falling back to a platform-derived domain. Null when neither is available.
export function useStorefrontUrl(): string | null {
  const { platform, store_id: storeId } = useEnv();
  const { merchantUrl } = useSettings();

  if (merchantUrl) {
    return /^https?:\/\//i.test(merchantUrl) ? merchantUrl : `https://${merchantUrl}`;
  }

  switch (platform) {
    case 'shopify':
    case 'shopify_plus':
      return storeId ? `https://${storeId}` : null;
    case 'bigcommerce':
      return storeId ? `https://store-${storeId}.mybigcommerce.com` : null;
    default:
      return null;
  }
}
